<template>
  <div class="Wrapper">
    <HStack
      :pstyle="{
        justifyContent: 'center',
        minWidth: '61px',
        maxWidth: '61px',
        marginRight: '1em',
      }"
    >
      <img :src="require(`../../../assets/${svg}`)" />
    </HStack>
    <div class="TextParent">
      <div class="Title">
        {{ text.header }}
      </div>
      <div class="Text">{{ text.text }}</div>
    </div>
  </div>
</template>

<script scoped>
import { HStack } from '../../../layout/flexbox';

export default {
  props: ['text', 'svg'],
  components: {
    HStack,
  },
};
</script>
<style scoped>
.Wrapper {
  --cardflat-m-bottom: 40px;
  --max-width: auto;
  --f-size: 14px;
  --padding: 0;
  display: flex;
  max-width: var(--max-width);
  margin-bottom: var(--cardflat-m-bottom);
  padding: var(--padding);
  color: #2b4047;
}
.Wrapper:last-of-type {
  margin-bottom: 0;
}
.Title {
  font-size: var(--f-size);
  font-weight: bold;
}
.Text {
  font-size: var(--f-size);
}
@media (min-width: 768px) {
  .Wrapper {
    display: flex;
    --cardflat-m-bottom: 0px;
  }
  .TextParent {
    min-height: 65px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
}

@media (min-width: 860px) {
  .Wrapper {
    display: block;
  }
  .TextParent {
    display: block;
    min-height: none;
  }
}
@media (min-width: 1024px) {
  .Wrapper {
    --padding: 0 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
@media (min-width: 1300px) {
  .Wrapper {
    --max-width: 250px;
    --f-size: 15px;
  }
}
@media (min-width: 1800px) {
  .Wrapper {
    --f-size: 20px;
    --max-width: 282px;
  }
}
</style>
